'use client';
import {BookingView} from "@web-libs/features/appointments/ui/booking/booking-view";

import cssStyles from './booking-page.module.css';
export type BookingPageProps = {

}

export const BookingPage = (props: BookingPageProps) => {

    return (
        <div className={cssStyles.appointmentPage}>
            <BookingView style={{gridArea:"left"}}></BookingView>
            <div style={{gridArea:"right"}}></div>
        </div>
    )
}
